export default {
  '/p/cs/fetchActionsInCustomizePage': '/api/cs/md/fetchActionsInCustomizePage',
  '/p/cs/menuimport': '/api/cs/md/menuimport',
  '/p/cs/proImage': '/api/cs/md/proImage',
  '/p/cs/matrix': '/api/cs/md/matrix',
  '/p/cs/judgePro': '/api/cs/md/judgePro',
  '/p/cs/cprospecload': '/api/cs/md/cprospecload',
  '/p/cs/cspecobjload': '/api/cs/md/cspecobjload',
  '/p/cs/cclrquery': '/api/cs/md/cclrquery',
  '/p/cs/cgroupsquery': '/api/cs/md/cgroupsquery',
  '/p/cs/groupTreeload': '/api/cs/md/groupTreeload',
  '/p/cs/changechruserpwd': '/api/cs/md/changechruserpwd',
  '/p/cs/resetchruserpwd': '/api/cs/md/resetchruserpwd',
  '/p/cs/queryMenuPermission': '/api/cs/md/queryMenuPermission',
  '/p/cs/savePermission': '/api/cs/md/savePermission',
  '/p/cs/copyPermission': '/api/cs/md/copyPermission',
  '/p/cs/getMatrixData': '/api/cs/oc/oms/v1/getMatrixData',
  '/p/cs/getMenuTree': '/api/cs/md/getMenuTree',
  '/p/cs/screen': '/api/cs/md/screen',
  '/p/cs/screenresult': '/api/cs/md/screenresult',
  '/p/cs/screenresultcheck': '/api/cs/md/screenresultcheck',
  '/p/cs/sg/storage/queryCommonStorageByPro': '/api/cs/sg/storage/queryCommonStorageByPro',
  // omsui
  '/p/cs/cdistribmultiquery': '/api/cs/md/cdistribmultiquery',
  // jflow
  '/r3/cs/scrm/getJflowProgres': '/api/cs/md/getJflowProgres',
  '/r3/cs/scrm/queryFields': '/api/cs/md/queryFields',
  '/r3/cs/scrm/checkModify': '/api/cs/md/checkModify',
  '/r3/cs/scrm/getPreviewFileUrl': '/api/cs/md/getPreviewFileUrl',
};
